/* eslint-disable class-methods-use-this */
import { AxiosRequestConfig, AxiosResponse } from 'axios';

import TokenService from 'app/domain/authentication/tokenService';

import httpService from './httpService';

interface ParamsProps {
  data?: any;
  headers?: Record<string, string | number | boolean>;
  method: 'get' | 'post' | 'put' | 'delete' | 'patch';
  params?: any;
  path: string;
  timeout?: number;
}

const httpRequest = async (parameters: ParamsProps): Promise<AxiosResponse> => {
  const { data, headers, method, params, path: url, timeout } = parameters;

  const requestOptions: AxiosRequestConfig = {
    data: data || null,
    headers: headers || {},
    method,
    params: params || null,
    timeout,
    url,
  };

  const accessToken = TokenService.getAccessTokenLS();

  if (accessToken) {
    requestOptions.headers = {
      ...requestOptions.headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const result = await httpService(requestOptions);
  return result;
};

export default httpRequest;
